export default function truckGroupNode(truckBaseColor = '#b8cae7') {
  const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
  group.setAttribute('width', 12);
  group.setAttribute('height', 28);
  group.setAttribute('transform', 'translate(0,0)');

  // Because the position is always calculated on x 0 and y 0, and we want
  // the truck to be centered exactly on that point. We add another group
  // that offsets the truck -50%, -50%.
  const truckIllustrationGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
  truckIllustrationGroup.setAttribute('transform', 'translate(-6,-14)');

  const truckTrailer = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  truckTrailer.setAttribute('x', 0);
  truckTrailer.setAttribute('y', 0);
  truckTrailer.setAttribute('width', 12);
  truckTrailer.setAttribute('height', 24);
  truckTrailer.setAttribute('fill', truckBaseColor);

  const truckCabin = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  truckCabin.setAttribute('x', 2);
  truckCabin.setAttribute('y', 24);
  truckCabin.setAttribute('width', 8);
  truckCabin.setAttribute('height', 4);
  truckCabin.setAttribute('fill', truckBaseColor);

  truckIllustrationGroup.appendChild(truckTrailer);
  truckIllustrationGroup.appendChild(truckCabin);

  group.appendChild(truckIllustrationGroup);

  return group;
}
